<template>
  <el-form :model="addMemberForm" :rules="addMemberRules" ref="addMemberForm">
    <el-row :gutter="60">
      <el-col :span="24" :md="24" :sm="24" :xs="24">
        <upload-item v-model="imgUrlObj"  :type="'members'" :label="'Members'"/>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="24" :md="12">
        <el-input-title required>First Name</el-input-title>
        <el-form-item prop="firstName">
          <el-input class="mt-05" v-model="addMemberForm.firstName" placeholder="Type here..." />
        </el-form-item>
      </el-col>
      <el-col :span="24" :md="12">
        <el-input-title required>Last Name</el-input-title>
        <el-form-item prop="lastName">
          <el-input class="mt-05" v-model="addMemberForm.lastName" placeholder="Type here..." />
        </el-form-item>
      </el-col>
      <el-col :span="24" :md="12">
        <el-input-title required>Birthdate</el-input-title>
        <el-form-item prop="birthdate">
          <el-date-input class="mt-05" v-model="addMemberForm.birthdate" placeholder="DD/MM/YYYY"/>
        </el-form-item>
      </el-col>
      <el-col :span="24" :md="12">
        <el-input-title required>Gender</el-input-title>
        <el-form-item prop="gender">
          <el-select class="mt-05 w-100" v-model="addMemberForm.gender" filterable :filter-method="handleGenderFilter" autocomplete placeholder="Select">
            <el-option
              v-for="item in filterGender"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24" :md="12">
        <el-form-item prop="mainProfile">
          <el-checkbox v-model="addMemberForm.mainProfile" >Make this my main profile</el-checkbox>
        </el-form-item>
      </el-col>
      <el-col :span="24" v-if="errorMessage">
        <el-alert show-icon type="error" :title="errorMessage" :closable="false" />
      </el-col>
    </el-row>
    <el-row class="mt-15">
      <el-col class="text-right">
        <el-button
          @click="cancel"
        >Cancel</el-button>
        <el-button
          type="primary"
          class="btn-highlight"
          @click="addMember"
        >Add Member</el-button>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import { genders } from '@/utils/constants';
import { checkBirthdate, parseBirthdate } from '../../utils/form-helpers';
import UploadItem from './components/UploadItem';

export default {
  name: 'NewMember',
  props: {},
  components: {
    UploadItem
  },
  data() {
    return {
      errorMessage: '',
      imgUrlObj: {},
      genders,
      nationalId: +process.env.VUE_APP_NATIONAL_ID,
      addMemberForm: {
        firstName: '',
        lastName: '',
        birthdate: '',
        gender: '',
        mainProfile: false
      },
      addMemberRules: {
        firstName: [
          { required: true, message: 'First Name is required', trigger: 'blur' }
        ],
        lastName: [
          { required: true, message: 'Last Name is required', trigger: 'blur' }
        ],
        birthdate: [
          { validator: checkBirthdate, trigger: 'blur' }
        ],
        gender: [
          { required: true, message: 'Gender is required', trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
    filterGender() {
      if (this.nationalId === 10) {
        return [
          { value: 'Male', label: 'Male' },
          { value: 'Female', label: 'Female' },
          { value: 'Non-binary', label: 'Non-binary' }
        ];
      }
      return [
        { value: 'Male', label: 'Male' },
        { value: 'Female', label: 'Female' },
        { value: 'Other', label: 'Other' }
      ];
    }
  },
  methods: {
    handleGenderFilter(val) {
      if (val) {
        this.filterGender = this.genders.filter((item) => item.value.charAt(0).toLowerCase() === val.charAt(0).toLowerCase());
      } else {
        this.filterGender = this.genders;
      }
    },
    cancel() {
      this.$emit('updateVisible', false);
    },
    addMember() {
      this.errorMessage = '';
      this.$refs.addMemberForm.validate((valid) => {
        if (valid) {
          this.$store.commit('loading', { loading: true, text: 'Loading...' });
          this.$http.post('/assemble/api/v1/account/portal/members/search', {
            firstName: this.addMemberForm.firstName,
            lastName: this.addMemberForm.lastName,
            dob: parseBirthdate(this.addMemberForm.birthdate),
            gender: this.addMemberForm.gender,
          }).then((res) => {
            const members = res.data.data;
            if (members && members.length > 0) {
              // Member match found -> link member
              this.$emit(
                'updatePage',
                { name: 'link-member', title: 'Previous Member Profiles' },
                { members, newMember: this.addMemberForm }
              );
              this.$store.commit('loading', false);
            } else {
              // Member match not found -> create new member
              this.$confirm("No previous profile found, you can click 'Cancel' to search again or click 'OK' to create as a new member.", 'New Member Confirm')
                .then(() => {
                  this.$http.post('/assemble/api/v1/account/portal/members', {
                    profile: {
                      firstName: this.addMemberForm.firstName,
                      lastName: this.addMemberForm.lastName,
                      dob: parseBirthdate(this.addMemberForm.birthdate),
                      gender: this.addMemberForm.gender,
                    },
                    imgUrlObj: this.imgUrlObj,
                    mainProfile: this.addMemberForm.mainProfile,
                  }).then(() => {
                    this.$emit('updateVisible', false);
                    this.$emit('refreshMembers');
                    this.$message({ message: 'Member added successfully', type: 'success' });
                    this.$store.commit('loading', false);
                  }).catch((e2) => {
                    this.errorMessage = e2.response.data.message;
                    this.$store.commit('loading', false);
                  });
                }).catch(() => {
                });
            }
            this.$store.commit('loading', false);
            this.$store.commit('loading', false);
          }).catch((e) => {
            this.errorMessage = e.response.data.message;
            this.$store.commit('loading', false);
          });
        }
      });
    }
  },
  watch: {
    // imgUrlObj(val) {
    //   this.imgUrlObj = val;
    // }
  }
};
</script>

<style lang="scss" scoped>
</style>
